import { z } from "zod";
import {
  entitlementKeySchema,
  isoDateTimeSchema,
  opaqueIdSchema,
  permissionKeySchema,
} from "./primitives";

export const scopeGrantSchema = z
  .object({
    scopeType: z.string().trim().min(1).max(80),
    scopeId: opaqueIdSchema,
  })
  .strict();

export const tenantAccessSchema = z
  .object({
    tenantId: opaqueIdSchema,
    tenantName: z.string().trim().min(1).max(200),
    subscriberAccountId: opaqueIdSchema,
    membershipId: opaqueIdSchema,
    permissions: z.array(permissionKeySchema).max(1_000),
    entitlements: z.array(entitlementKeySchema).max(500),
    scopes: z.array(scopeGrantSchema).max(5_000).default([]),
    evidenceScopes: z.array(scopeGrantSchema).max(5_000).optional(),
  })
  .strict();

export const identityContextSchema = z
  .object({
    userId: opaqueIdSchema,
    email: z.string().email().max(320),
    displayName: z.string().trim().min(1).max(200).optional(),
    authenticatedAt: isoDateTimeSchema,
    sessionExpiresAt: isoDateTimeSchema,
    tenants: z.array(tenantAccessSchema).max(500),
  })
  .strict();

export type IdentityContext = z.infer<typeof identityContextSchema>;
export type TenantAccess = z.infer<typeof tenantAccessSchema>;

export const tenantContextSchema = z
  .object({
    tenantId: opaqueIdSchema,
    tenantName: z.string().trim().min(1).max(200),
    subscriberAccountId: opaqueIdSchema,
    legalEntityId: opaqueIdSchema.optional(),
    permissions: z.array(permissionKeySchema).max(1_000),
    entitlements: z.array(entitlementKeySchema).max(500),
    scopes: z.array(scopeGrantSchema).max(5_000).default([]),
    evidenceScopes: z.array(scopeGrantSchema).max(5_000).optional(),
  })
  .strict();

export type TenantContext = z.infer<typeof tenantContextSchema>;

